import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";
import { pushIf } from "./utils/pushIf";

const reduceListEditionNotificationState = createStateReducer(initialState, {
  [events.editListSucceeded]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "editList",
        flags: ["success"],
        args: { success: "true" },
      },
      state.queue,
    ),
  }),
  [events.editListFailed]: (state, { error }) => ({
    ...state,
    queue: updateNotification(
      {
        key: "editList",
        flags: pushIf({
          ...error,
          failure: !Object.values(error).includes(true),
        }),
        args: { failure: "true" },
      },
      state.queue,
    ),
  }),
});

export { reduceListEditionNotificationState };
